// TODO: Once user profile api is available we will replace it
const getUserProfileService = () => Promise.resolve();

export default getUserProfileService;
